import Vue from 'vue';
import $ from 'jquery';
import cookie from 'cookie';
import router from './router';
import Axios from 'axios';
import VueAxios from 'vue-axios';
// import store from './vuex/store';
import store from './vuex/index.js';
import VueResource from 'vue-resource';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import { newCommon } from './plugins/directives';
import './plugins/drag';
import tools from './utils/tools';
import './styles/common.scss';
import './plugins/filters';
import 'video.js/dist/video-js.css';
import 'babel-polyfill';
//时间处理插件
import moment from 'moment';
// 复制插件
// import VueClipboard from 'vue-clipboard2'
//api接口
import api from './server/index';
import { use } from 'echarts/core';
// 手动引入 ECharts 各模块来减小打包体积

Vue.prototype.$api = api;
Vue.use(VueAxios, Axios, VueResource, $).use(cookie).use(ElementUI, { size: 'small' })

Vue.prototype.index = new Vue();
Axios.defaults.withCredentials = true;
Vue.prototype.$axios = Axios;
Vue.prototype.newCommon = newCommon;
Vue.prototype.$tools = tools;
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

var vm = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
});

// Vue.prototype.index.search;
Vue.prototype.locationOnload = (routers) => {
    vm.$router.replace({ path: '/entry' + routers });
};
Vue.prototype.search = () => {
    vm.index.search.getListData('1');
};



// WEBPACK FOOTER //
// ./src/main.js